import { Text } from '../../basics'

export function Header() {
  // TODO: Modify to get from localstorage
  const title = 'デバイス設定'
  return (
    <div className="flex flex-col items-center">
      <Text className="text-[58px]" weight="bold" size="heading1">
        {title}
      </Text>
    </div>
  )
}
